
import { readUpdateNoticeAPI } from '@/api/common';

export default {
  name: 'XrUpgradeDialog',
  components: {},
  props: {
    visible: Boolean
  },
  data: function data() {
    return {
      message: '\n\u4FEE\u590D\uFF1A\n1\u3001\u4FEE\u590D\u5176\u4ED6\u5DF2\u77E5bug\u3002'
    };
  },

  computed: {},
  watch: {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {
    closeView: function closeView() {
      readUpdateNoticeAPI().then(function (res) {}).catch(function () {});
      this.$emit('update:visible', false);
    }
  }
};